/**
 * @author      yontaek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2022, Zumper
 * @description getSearchUrlFromPathAndFilters
 */

import { updateUrlParam } from '@zcode/nr/es/shared/utils/urls/updateUrlParam'
import type { FiltersState } from '@zcode/state-type'
import {
  FILTER_TYPES,
  MAX_NIGHTLY_FILTER_PRICE,
  MIN_FILTER_PRICE,
  URL_FILTER_QUERY_KEYS,
} from '../../constants/filterConstants'

export const getShortTermSearchUrlFromFilters = ({
  filters,
}: {
  filters: FiltersState
}) => {
  let url = ''
  const brs: number[] = []

  // bedrooms
  if (filters.bedrooms.length) {
    filters.bedrooms.forEach((value: boolean, i: number) => {
      if (value) {
        // iterable of booleans
        brs.push(i)
      } else if (value && value !== undefined) {
        // iterable of non-booleans aka integers
        brs.push(value)
      }
    })

    if (brs.length) {
      url = updateUrlParam(url, 'bedrooms', brs.join(','))
    }
  }

  // bathroom
  if (filters.bathroomsRange.length) {
    url = updateUrlParam(url, 'bathrooms-range', filters.bathroomsRange.join(','))
  }

  // guests
  if (filters.guests?.length) {
    url = updateUrlParam(url, 'guests', filters.guests.join(','))
  }

  // startDate & endDate
  url = updateUrlParam(
    url,
    URL_FILTER_QUERY_KEYS[FILTER_TYPES.START_DATE],
    filters.startDate ?? null
  )
  url = updateUrlParam(url, URL_FILTER_QUERY_KEYS[FILTER_TYPES.END_DATE], filters.endDate ?? null)

  // lease-term
  if (filters.shortTerm) {
    url = updateUrlParam(url, 'lease-term', 'short')
  } else {
    url = updateUrlParam(url, 'lease-term', null)
  }

  if (filters.minNightlyPrice !== MIN_FILTER_PRICE) {
    url = updateUrlParam(url, 'min-price', filters.minNightlyPrice)
  }

  if (filters.maxNightlyPrice !== MAX_NIGHTLY_FILTER_PRICE) {
    url = updateUrlParam(url, 'max-price', filters.maxNightlyPrice)
  }

  return url
}
